/** @jsx jsx */
import { customColors } from '@apollo/orbit';
import { TextField } from '@apollo/space-kit/TextField';
import { css, jsx } from '@emotion/react';
import classnames from 'classnames';
import React from 'react';

const InputWithStatus = ({
  status,
  error,
  className,
  ...props
}: React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  error: React.ComponentProps<typeof TextField>['error'];
  status?: React.ReactElement;
}) => {
  return (
    <div
      css={css`
        /* "focus:hover:border-blue-light" does not work */
        &:focus:hover {
          border-color: ${customColors.border.info};
        }
      `}
      className={classnames(className, 'flex focus:border-info', {
        'border-error hover:border-error': !!error,
      })}
    >
      <input {...props} type="url" className="h-9 flex-1 bg-transparent" />
      {status && (
        <div className="float-right my-2 ml-2 flex items-center">{status}</div>
      )}
    </div>
  );
};
export const TextFieldWithStatus = ({
  status,
  ...props
}: React.ComponentProps<typeof TextField> & {
  status?: React.ReactElement;
}) => {
  return (
    <TextField
      {...props}
      inputAs={<InputWithStatus status={status} error={props.error} />}
    />
  );
};
